import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ScrollEvent from './scroll-event';
import { scroller } from 'react-scroll';
import Tabs from './tabs';
import TabSelectBar from './tab-select-bar';


class TabsContainer extends Component {

  state = {
    tabIndex: 0
  }

  static defaultProps = {
    handleTabChange: () => {}
  }

  static propTypes = {
    handleTabChange: PropTypes.func
  }

  componentDidUpdate(prevProps, prevState){
    const { tabIndex } = this.props;
    if(typeof tabIndex === 'number' && (tabIndex !== this.state.tabIndex)){
      this.setState({
        tabIndex: tabIndex
      });
    }
  }

  handleTabChange = (index, scroll, isTabSticky) => {
    const { tabIndex, handleTabChange } = this.props;

    if(index != this.state.tabIndex){
      this.setState({
        tabIndex: index
      });
    }

    this.props.handleTabChange(index, scroll, isTabSticky)
  }

  render(){
    const {product, tabIndex, children} = this.props;
    let index = this.state.tabIndex;

    //if tabIndex not provided ,
    const tabChildren = React.Children.map(
      children,
      (child, i) => {

        if(child.type === Tabs) {
          return React.cloneElement(child, {
            tabIndex: index,
            product: product,
          });
        }
        else if(child.type === TabSelectBar) {
          return React.cloneElement(child, {
            handleTabChange: this.handleTabChange,
            tabIndex: index,
          });
        }
        else {
          return child;
        }
      }
    );


    return (
      <div className='tabs-container'>
      {tabChildren}
      </div>
    );
  }
}

export default TabsContainer;
